import type { LocationQueryValue } from "vue-router";

export const getNormalizedQueryParams = <T>(
  queryParams: LocationQueryValue | LocationQueryValue[],
): T[] => {
  let normalizedQueryParams = queryParams;

  // Normalize `String` to an `Array`, if a single query parameter was given.
  if (!Array.isArray(normalizedQueryParams)) {
    normalizedQueryParams = [normalizedQueryParams];
  }

  return normalizedQueryParams.filter(Boolean) as T[];
};
